import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { EyeIcon, KyuLaurelBadgeIcon, RichResourceIcon } from 'app/components/shared/icons';
import CrossedEyeIcon from 'app/components/shared/icons/crossed-eye';
import { setDialogOpen } from 'store/reducers/global/global-reducer';

import {
  ResourceSubmissionUnpublishDialogButtonCancel,
  ResourceSubmissionUnpublishDialogButtonText,
  ResourceSubmissionUnpublishDialogButtonConfirm,
  ResourceSubmissionUnpublishDialogButtons,
  ResourceSubmissionUnpublishDialogText,
  ResourceSubmissionUnpublishDialogWrapper,
  ResourceSubmissionUnpublishDialogIconContainer,
} from './styled';

interface ResourceSubmissionUnpublishDialogProps {
  onConfirm: () => void;
  onCancel: () => void;
  isPublish?: boolean;
}

export default function ResourceSubmissionUnpublishDialog({
  onConfirm,
  onCancel,
  isPublish = false,
}: ResourceSubmissionUnpublishDialogProps) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setDialogOpen(true));
    return () => {
      dispatch(setDialogOpen(false));
    };
  }, []);

  return (
    <ResourceSubmissionUnpublishDialogWrapper>
      <ResourceSubmissionUnpublishDialogIconContainer>
        <RichResourceIcon width={40} height={40} />
      </ResourceSubmissionUnpublishDialogIconContainer>
      <ResourceSubmissionUnpublishDialogText>
        {isPublish ? (
          <>Are you sure you’d like to make this resource findable?</>
        ) : (
          <>
            Are you sure you’d like to unpublish this resource?
            <br />
            <br />
            This will hide the resource from everyone except you.
          </>
        )}
      </ResourceSubmissionUnpublishDialogText>
      <ResourceSubmissionUnpublishDialogButtons>
        <ResourceSubmissionUnpublishDialogButtonCancel onClick={onCancel}>
          <ResourceSubmissionUnpublishDialogButtonText>
            No, I changed my mind
          </ResourceSubmissionUnpublishDialogButtonText>
        </ResourceSubmissionUnpublishDialogButtonCancel>
        <ResourceSubmissionUnpublishDialogButtonConfirm onClick={onConfirm}>
          <ResourceSubmissionUnpublishDialogButtonText>
            {isPublish ? 'Yes, make this resource findable' : 'Yes, unpublish this resource'}
          </ResourceSubmissionUnpublishDialogButtonText>
          {isPublish ? (
            <EyeIcon width={24} height={24} fill="var(--color-primary)" />
          ) : (
            <CrossedEyeIcon width={24} height={24} fill="var(--color-primary)" />
          )}
        </ResourceSubmissionUnpublishDialogButtonConfirm>
      </ResourceSubmissionUnpublishDialogButtons>
    </ResourceSubmissionUnpublishDialogWrapper>
  );
}
